import { AppBar, Toolbar, Typography, IconButton, Button, Chip, Stack, Box, Tooltip } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import LogoutIcon from '@mui/icons-material/Logout'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import LightModeIcon from '@mui/icons-material/LightMode'
import { useAuth } from '@/contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { useThemeMode } from '@/contexts/ThemeContext'

interface HeaderProps {
  onMenuToggle?: () => void
}

const Header = ({ onMenuToggle }: HeaderProps) => {
  const { logout, user } = useAuth()
  const navigate = useNavigate()
  const { mode, toggleMode, theme } = useThemeMode()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <AppBar position="static" elevation={0}>
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          sx={{ mr: 2, display: { md: 'none' } }}
          onClick={onMenuToggle}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img src="/logo.png" alt="Logo" style={{ maxHeight: '40px', width: 'auto', marginRight: '12px' }} />
        </Box>
        <Stack direction="row" spacing={2} alignItems="center">
          {user && (
            <>
              <Typography variant="body2">{user.email}</Typography>
              <Chip label={user.role === 'super_admin' ? 'Super Admin' : 'Viewer'} size="small" color="secondary" />
            </>
          )}
          <Tooltip title={theme.palette.mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton color="inherit" onClick={toggleMode}>
              {theme.palette.mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
          </Tooltip>
          <Button color="inherit" startIcon={<LogoutIcon />} onClick={handleLogout}>
            Logout
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

export default Header

